import { render, staticRenderFns } from "./SortSelector.vue?vue&type=template&id=4a735faf&scoped=true&"
import script from "./SortSelector.vue?vue&type=script&lang=js&"
export * from "./SortSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a735faf",
  null
  
)

export default component.exports